import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';

import { BaseDrawerComponent } from '@base/base-drawer.component';
import { ICONS } from '@models';

@Component({
    selector: 'vz-select-icon',
    templateUrl: './select-icon-drawer.component.html',
    styleUrls: ['./select-icon-drawer.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        NzDrawerModule, NzButtonModule,
    ],
})
export class SelectIconDrawerComponent extends BaseDrawerComponent {
    color = input<string>();
    icons = ICONS;
}
